import type { CallConfiguration, CallStatus } from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

export function createCall(
  transport: Transport,
  {
    callId,
    fromAccountId,
    toAccountId,
    feedId,
  }: { callId: string; fromAccountId: string; toAccountId: string; feedId: string },
): Promise<CallConfiguration> {
  return operations.postCall(transport, { callId, body: { fromAccountId, toAccountId, feedIds: [feedId] } });
}

export function createCallEvent(
  transport: Transport,
  { callId, callStatus, durationSeconds }: { callId: string; callStatus: CallStatus; durationSeconds?: number | null },
): Promise<void> {
  return operations.postCallCallEvent(transport, { callId, body: { callStatus, durationSeconds } });
}
